/**
 * Quote subfolder service helpers — TS-060 (DEC-COUNCIL-015).
 *
 * Encapsulates project subfolder lazy-creation and 99. QM output folder resolution.
 */

import { generateProjectName } from '../utils/project-name-generator';
import { FileSystemService } from './file-system';
import { QM_OUTPUT_SUBFOLDER } from '../config/folder-conventions';

export interface EnsureQuoteSubfolderParams {
    quoteSubfolder: any;
    parentFolder: any;
    formData: any;
    setQuoteSubfolder?: (subfolder: any) => void;
}

export function generateSubfolderName(formData: any): string {
    return generateProjectName(formData);
}

export async function ensureQuoteSubfolder({
    quoteSubfolder,
    parentFolder,
    formData,
    setQuoteSubfolder,
}: EnsureQuoteSubfolderParams): Promise<any> {
    if (quoteSubfolder?.handle) {
        return quoteSubfolder.handle;
    }

    if (!parentFolder?.handle) {
        return null;
    }

    const name = generateSubfolderName(formData);
    try {
        const handle = await FileSystemService.createSubfolder(parentFolder.handle, name);
        if (setQuoteSubfolder) {
            setQuoteSubfolder({ name, folderName: name, relativePath: name, path: name, sourcePath: name, handle });
        }
        return handle;
    } catch (err) {
        console.error('Failed to create quote subfolder:', err);
        throw err;
    }
}

export async function ensureQmOutputSubfolder({
    quoteSubfolder,
    parentFolder,
    formData,
    setQuoteSubfolder,
}: EnsureQuoteSubfolderParams): Promise<any> {
    const projectDir = await ensureQuoteSubfolder({
        quoteSubfolder,
        parentFolder,
        formData,
        setQuoteSubfolder,
    });
    if (!projectDir) return null;
    return await FileSystemService.createSubfolder(projectDir, QM_OUTPUT_SUBFOLDER);
}
